exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wrapper{background-color:#fff;padding:8px;border-radius:6px;width:100%}.timer-counter{color:#722ed1;font-weight:bold}.title-counter{font-weight:bold;max-width:160px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:100%}.timer-desc-counter{color:#4c4d66;font-size:12px;margin-top:8px}", ""]);

// exports
